import axios from '@/modules/axios';

function configAuthAxios(teamName) {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common = { 'X-ByteArk-Team': teamName };

  const baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;
  axios.defaults.baseURL = `${baseURL}/api/v1`;
}

export default configAuthAxios;
